
import { useState, useEffect, useRef } from "react";
import styles from '../style.module.css';
import AdvantagesItem from './AdvatagesItem';

function Advantages() {

    const containerRef = useRef(null);
    const [startAnimation, setStartAnimation] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    console.log('START');
                    setStartAnimation(true);
                    observer.disconnect();
                }
            },
            {
                threshold: 0.3,
            }
        );
        if (containerRef.current) {
            observer.observe(containerRef.current);
        }
        return () => observer.disconnect();
    }, []);


    return (
        <div
            className = {styles.advantages_container}
            ref={containerRef}
        >
            <div className={styles.advantages_contents}>
                <div className={styles.advantages_text_content}>
                    <div className={styles.advantages_text_content_top}>
                        <span>
                            Advantages
                        </span>
                        <span>
                            Lorem Ipsum is simply dummy text of the printing
                        </span>
                    </div>
                    <div className={styles.advantages_text_content_bottom}>
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                        Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                        when an unknown printer took a galley of type and scrambled it to make
                    </div>
                </div>
                <div className={styles.advantages_items_box}>
                    <AdvantagesItem
                        value = { '20+' }
                        title = { 'Lorem Ipsum is simply' }
                        text = { 'Lorem Ipsum is simply dummy text of the printing and typesetting industry' }
                        startAnimation = { startAnimation }
                    />
                    <AdvantagesItem
                        value = { '10000' }
                        title = { 'Lorem Ipsum is simply' }
                        text = { 'Lorem Ipsum is simply dummy text of the printing and typesetting industry' }
                        startAnimation = { startAnimation }
                    />
                    <AdvantagesItem
                        value = { '180+' }
                        title = { 'Lorem Ipsum is simply' }
                        text = { 'Lorem Ipsum is simply dummy text of the printing and typesetting industry' }
                        startAnimation = { startAnimation }
                    />
                    <AdvantagesItem
                        value = { '2000' }
                        title = { 'Lorem Ipsum is simply' }
                        text = { 'Lorem Ipsum is simply dummy text of the printing and typesetting industry' }
                        background = { 'var(--red)' }
                        textColor = {'white'}
                        startAnimation = { startAnimation }
                    />
                </div>
            </div>
        </div>
    )
}

export default Advantages;